import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyMenu as MatMenu } from '@angular/material/legacy-menu';
import { MetricKey } from '@app/shared/+state/metrics';
import { Filter } from '@app/shared/interfaces/lib/filter.interface';
import { SaveViewDialogComponent } from '../save-view-dialog/save-view-dialog.component';

@Component({
  selector: 'hospitable-save-view',
  templateUrl: './save-view.component.html',
  styleUrls: ['./save-view.component.scss'],
})
export class SaveViewComponent implements OnInit {
  @Input() metricKey: MetricKey;
  @Input() appliedFilters: Filter[];
  @ViewChild(MatMenu, { static: false }) menu: MatMenu;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  openSaveViewDialog() {
    this.dialog.open(SaveViewDialogComponent, {
      width: '720px',
      maxHeight: '90vh',
      data: {
        metricKey: this.metricKey,
        appliedFilters: this.appliedFilters,
      },
    });
  }
}
